import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { editUser, saveUser, superadmin, isEdit, processing, setisEdit, openSendEmailModal, openGracePeriodModal }
) =>{

  const callEditFunction = async (row) => {
    editUser(row);
  }
  const callSaveUserFunction = async (row) => {
    saveUser(row);
  }
  const callCancelButtonFunction = async () => {
    setisEdit('');
  }

  if(isEdit === row.id)
  {
    if(processing === "save"+row.id)
    {
      return (<i className="fas fa-circle-notch fa-spin"></i>)
    }
    else
    {
      return (
        <>
          <button type="button" className="btn btn-primary" onClick={()=>callSaveUserFunction(row)}>Save</button>
          <button type="button" className="btn btn-danger ml-1" onClick={()=>callCancelButtonFunction()}>Cancel</button>
        </>
      )
    }
  }
  else
  {
    return (
      <div className="d-inline-flex align-items-center text-nowrap">
        <OverlayTrigger
          overlay={<Tooltip id="users-edit-tooltip">Edit user</Tooltip>}
        >
          <a
            href="#"
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
            onClick={(e) => { e.preventDefault(); callEditFunction(row); }} 
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>

        <OverlayTrigger
          overlay={<Tooltip id="users-grace-period-tooltip">Update Grace Period</Tooltip>}
        >
          <a
            href="#"
            className="btn btn-icon btn-light btn-hover-warning btn-sm mx-1"
            onClick={(e) => { e.preventDefault(); if (openGracePeriodModal) openGracePeriodModal(row); }}
          >
            <span className="svg-icon svg-icon-md svg-icon-warning">
              <i className="fa fa-calendar-alt text-warning"></i>
            </span>
          </a>
        </OverlayTrigger>

        <OverlayTrigger
          overlay={<Tooltip id="users-send-email-tooltip">Send custom email</Tooltip>}
        >
          <a
            href="#"
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
            onClick={(e) => { e.preventDefault(); openSendEmailModal(row); }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <i className="fa fa-envelope text-primary"></i>
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
  }
}
